export const DASHBOARD_CONSTANTS = {
  DEFAULT_ITEMS_PER_PAGE: 10,
  EXPIRY_WARNING_MONTHS: 1,
  ITEMS_PER_PAGE_OPTIONS: [10, 25, 50, 100],
}
